export default {
  async search({ commit }, payload) {
    console.log(commit, payload);
    // return search(payload)
    //   .then(res => {
    //     commit('searchResults', res);
    //   })
  },
}
